<template>
  <svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-14 w-14 fill-blue-200"
      viewBox="0 0 72 72"
    >
      <g data-name="Layer 1">
        <circle
          cx="36"
          cy="36"
          r="36"
          data-name="Ellipse 142"
          class="fill-primary-50"
        />
        <g data-name="Group 5346">
          <rect
            width="17"
            height="13"
            x="28"
            y="29"
            data-name="Rectangle 1057"
            rx="5"
            ry="5"
            style="fill: #fff"
          />
          <g data-name="Group 5345">
            <path
              d="M40.24 24.14c-1.04-.44-2.05-.95-3.03-1.53-.44-.26-.84-.51-1.21-.74-.37.23-.78.48-1.21.74-.97.58-1.98 1.09-3.03 1.53-2.25.94-4.61 1.61-7.02 2-.42.07-.86.13-1.31.18l1.08 6.52c.16.94.41 2.54.56 3.58.1.52.23 1.03.39 1.54.14.48.32.99.52 1.51.49 1.21 1.08 2.37 1.79 3.47 1 1.57 5.03 4.94 8.24 7.35 3.22-2.41 7.24-5.78 8.24-7.35.7-1.1 1.3-2.26 1.79-3.48.2-.5.38-1.01.52-1.5.16-.51.29-1.02.39-1.54.15-.98.39-2.58.56-3.58l1.08-6.51c-.45-.05-.89-.11-1.31-.18-2.41-.39-4.77-1.06-7.02-2Zm-5.19 17.02L29 35.12l2.55-2.55 3.5 3.5 6.88-6.88 2.54 2.55-9.43 9.43Z"
              data-name="Path 38886"
              class="fill-primary-500"
            />
            <path
              d="M36 18.41c.52.38 1.34.93 2.68 1.74.86.51 1.75.96 2.67 1.35 2.05.85 4.19 1.46 6.38 1.81 1.42.24 3.25.36 4.18.42l-1.58 9.59c-.16.96-.41 2.56-.56 3.55-.12.65-.28 1.29-.47 1.92a22.81 22.81 0 0 1-2.65 5.7c-1.7 2.67-8.1 7.54-10.44 9.2-.07.05-.15.1-.22.15-.07-.04-.15-.1-.23-.15-2.32-1.65-8.72-6.52-10.43-9.19a24.29 24.29 0 0 1-2.04-3.96c-.24-.6-.44-1.19-.61-1.75-.19-.63-.35-1.26-.47-1.91-.14-.91-.39-2.53-.56-3.56l-1.58-9.59c.93-.05 2.76-.18 4.18-.42 2.19-.35 4.33-.96 6.38-1.81.92-.39 1.81-.84 2.67-1.35 1.35-.8 2.17-1.36 2.69-1.74Zm0-2.46a.9.9 0 0 0-.5.16c-1.01.86-2.11 1.6-3.27 2.23-.77.46-1.58.87-2.41 1.22a25.65 25.65 0 0 1-5.9 1.67c-1.84.31-4.52.42-4.52.42a1.543 1.543 0 0 0-1.49 1.84l1.68 10.18c.16.97.41 2.56.55 3.52.13.74.31 1.48.53 2.2.17.56.39 1.21.67 1.92.6 1.5 1.34 2.95 2.22 4.31 2.3 3.6 10.99 9.78 10.99 9.78.39.31.85.54 1.34.65h.21c.5-.12.96-.34 1.36-.65 0 0 8.69-6.17 10.99-9.78.87-1.36 1.62-2.81 2.22-4.31.28-.71.5-1.36.67-1.92.23-.72.4-1.46.54-2.2.14-.97.39-2.56.55-3.52l1.68-10.18c.16-.84-.39-1.65-1.23-1.81-.09-.02-.18-.03-.27-.03 0 0-2.68-.11-4.52-.42a25.65 25.65 0 0 1-5.9-1.67c-.83-.35-1.64-.76-2.41-1.22-1.16-.63-2.26-1.37-3.27-2.23a.94.94 0 0 0-.52-.16Z"
              data-name="Path 38887"
              class="fill-primary-700"
            />
          </g>
        </g>
      </g>
    </svg>
  </svg>
</template>

<script>
export default {
  name: "ShiedLogo",
}
</script>
